<template>
    <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->

        <div>
            <!-- <div v-for="(answer,index) in answers" :key="'answer_'+index"> -->
                <div v-for="(message,index) in answers[intent_index]" :key="'answer_message_'+index"  style="margin-bottom: 5px;">
                    <template v-if="message.type == 'text'">

                        <div class="message" style="float:left;position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;">
                            <div style="font-size: 12px;" :style="{'color': color}">
                                <div style="padding: 5px 8px 6px;" :style="{'background-color': background}">
                                    <span style="line-height:15.36px;"><specialtext :text="message.value.text"></specialtext></span>
                                </div>
                            </div>
                            <div v-if="message.value.buttons && message.value.buttons.length > 0" style="float:left;width: 100%;border: 1px solid #eee; border-bottom-right-radius: 12px;border-bottom-left-radius: 12px;overflow: hidden">
                                <ul class="list-group list-group-flush" style="margin-bottom: 0px;" >
                                    <li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center;padding: 2px 15px" v-for="(button,bindex) in message.value.buttons" :key="bindex" :style="{'border-top': bindex != 0 ? '1px solid #eee' : 'none', 'padding' : !showDeep ? '10px 0' : '2px 15px'}">
                                        <span style="color: #0084FF">{{ button.title | truncate(20) }}</span>
                                        <div style="margin: 0;font-size: 10px;" v-if="showDeep">
                                            <span v-if="button.type == 'web_url'" :title="button.url">{{button.url | truncate(20)}}</span>
                                            <span v-else-if="button.type == 'postback'" :title="button.payload">{{button.payload | truncate(20)}}</span>
                                            <span v-else-if="button.type == 'phone_number'" :title="button.payload">{{button.payload | truncate(20)}}</span>
                                            <span v-else>&nbsp;</span>
                                        </div> 
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                    </template>
                    <template v-else-if="message.type == 'image'">
                        <div class="message" style="float:left;position:relative;border-radius: 12px;width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;">
                            <div style="font-size: 12px;color:black">
                                <img :src="message.value" alt="" style="width: 100%">
                            </div>
                        </div>
                    </template>
                        <div class="clearfix"></div>
                </div>
            <!-- </div> -->
        </div>
    <!-- </transition> -->
</template>

<script>
import specialtext from '@/components/elements/specialtext'
    export default {
        props: {
            value: [Object,String],
            background: {
                type: String,
                default: '#F1F0F0'
            },
            color: {
                type: String,
                default: 'black'
            },
            showDeep: {
                type: Boolean,
                default: true
            }
        },
        data: function(){
            return {
                group: this.value,
                intent_index: 0,
            }
        },
        components: {
            specialtext
        },
        mounted: function(){
            var vm = this
            if (vm.answers.length > 1) {
                
                setInterval(() => {
                    if (vm.intent_index == vm.answers.length - 1) {
                        vm.intent_index = 0
                    } else {
                        vm.intent_index++
                    }
                }, 10000);
            }
        },
        computed: {
            answers: function(){
                var vm = this
                if (vm.group == null) {
                    return []
                }
                var group = []
                // try {
                    var group_messages = vm.group.split('||')  
                    $.each(group_messages,function(index, messages){
                        var messages = messages.split('#nl') 
                        var newMessages = []   
                        $.each(messages, function(inedx, message){
                            if (vm.isURL(message)) {
                                newMessages.push(
                                    {
                                        type: 'image',
                                        value: message
                                    }
                                )
                            } else if (!isNaN(message)) {
                                newMessages.push({
                                    type: 'text',
                                    value: {
                                        text: message,
                                        buttons: []
                                    }
                                })
                            } else if(vm.isJsonParseable(message)) {
                                newMessages.push(
                                    {
                                        type: 'text',
                                        value: JSON.parse(message)
                                    }
                                )
                            } else {
                                newMessages.push(
                                    {
                                        type: 'text',
                                        value: {
                                            text: message,
                                            buttons: []
                                        }
                                    }
                                )
                            }
                        })
                        group.push(newMessages)
                    })
                // } catch (error) {
                //     // console.log(vm.group)
                // }
                
                
                return group
			},
        },
        methods: {
            isURL: function(str) {
                var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?'+ // port
                '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
                '(\\?[;&a-z\\d%@_.,~+&:=-{}()]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                return pattern.test(str);
            },
            isJsonParseable: function(str){
				try {
					JSON.parse(str);
				} catch (e) {
					return false;
				}
				return true
			},
            isNumber: function(str) {
                try {
                    parseFloat(str);
				} catch (e) {
					return false;
				}
				return true
            },
        },
        watch: {
            value: function(){
                this.group = this.value
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/MessageViewer.vue